import React from 'react';
import Card from '../Cards/cards.component';

import './listing.styles.scss';

export const Listing = props => {
	return (
		<section className="listing-wrapper">
			<div className="container">
				<ul>
					{
						props.data.slice(0, props.size).map((card, i) => (
							<Card
								key={i}
								title={card.title.rendered}
								description={card.acf.description}
								image={card.acf.image}
								content={card.acf.content}
								industry={card.acf.industry}
								link={card.acf.link}
								caseStudyBoolean={card.acf.case_study_boolean}
								caseStudy={card.acf.case_study}
								slug={card.slug}
							/>
						))
					}
				</ul>
			</div>
		</section>
	)
}